import React from "react";
import '../css/NavBar.css'; 
import { NavLink } from 'react-router-dom';

const navLinkClass = (activeState) => {
    return activeState ? 'nav-link active' : 'nav-link inactive'
}

function Navbar() {
    
    

    function hamburgerClick(){
        const hamburger = document.querySelector('.hamburger');
        const navMenu = document.querySelector('.nav-menu');
        const navBar = document.querySelector('.navbar');
        hamburger.classList.toggle("active");
        navMenu.classList.toggle("active");
        hamburger.classList[1]==='active'? navBar.style.backgroundColor = "#232323f9" : navBar.style.backgroundColor = "rgba(0, 0, 0, 0.45)";
    };

    function handleNavLinkCLick(){
        var screenWidth = window.innerWidth;
        console.log("click", screenWidth);
        if (screenWidth < 989) {
            hamburgerClick(); 
        }
    }

    window.addEventListener('resize', function() {
        const navBar = document.querySelector('.navbar');
        const navMenu = document.querySelector('.nav-menu');
        if (window.innerWidth > 990 && navMenu.classList.contains("active")) {
            navBar.style.backgroundColor = "rgba(0, 0, 0, 0.45)"
            hamburgerClick();
        } 
      });
  

  return (
    <header>
        <div className="navbar-container">
            <nav className="navbar">
                <ul className="nav-menu">
                <NavLink to="/" end className={({isActive}) => navLinkClass(isActive)} onClick={handleNavLinkCLick}>
                   Home 
                </NavLink>
                <NavLink to="/about" className={({isActive}) => navLinkClass(isActive)} onClick={handleNavLinkCLick}>
                    About
                </NavLink>
                <NavLink to="/posts" className={({isActive}) => navLinkClass(isActive)} onClick={handleNavLinkCLick}>
                    Posts
                </NavLink>

                <NavLink to="/projects" className={({isActive}) => navLinkClass(isActive)} onClick={handleNavLinkCLick}>
                    Projects
                </NavLink>
                </ul>
                <div className="hamburger" onClick={hamburgerClick}>
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                </div>
            </nav>
        </div>
    </header>
   
    
  );
}

export default Navbar;